import React, { useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ru"; // импорт русской локали
import locale from "antd/es/date-picker/locale/ru_RU"; // локализация для antd

dayjs.locale("ru"); // установка локали для dayjs

function DateTimePicker({ onChange }) {
    const [dateTime, setDateTime] = useState(null);

    const handleChange = (value) => {
        setDateTime(value);
        if (onChange) {
            onChange(value ? value.toISOString() : null);
        }
    };

    return (
        <div className='w-full mx-auto'>
            <p className='text-left text-[12px] font-medium mb-[6px]'>
                Дата и время визита
            </p>

            <DatePicker
                placeholder='Выбрать'
                showTime={{ format: "HH:mm" }}
                format='YYYY-MM-DD HH:mm'
                value={dateTime}
                onChange={handleChange}
                locale={locale} // 👈 вот тут анtd получает русскую локализацию
                inputReadOnly
                className='w-full text-[14px]'
                style={{
                    borderRadius: "8px",
                    padding: "10px 16px",
                }}
            />
        </div>
    );
}

export default DateTimePicker;
